'use client';

import { ComponentType, Suspense } from 'react';

/* @jsxImportSource react */

export function withSuspense<Props>(Component: ComponentType<Props>) {
  return function (props: Props) {
    return (
      <Suspense>
        {/* @ts-expect-error: emotion conflict */}
        <Component {...props} />
      </Suspense>
    );
  };
}
